import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import PriorHeader from "@/components/PriorHeader.vue";
import PriorFooter from "@/components/PriorFooter.vue";
import { ref } from "vue";
import { miscService } from "@/services/miscService";
import { ApiError } from "@/services/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OpsUtilities',
    setup(__props) {
        const errorMessage = ref("");
        const loading = ref(false);
        const s3LinksForRefresh = ref("");
        const refreshedS3Links = ref([]);
        const refreshS3Link = async () => {
            errorMessage.value = "";
            try {
                loading.value = true;
                const s3Links = s3LinksForRefresh.value
                    .replaceAll(/[\[\]'"]/g, "")
                    .trim()
                    .split(",")
                    .map((link) => link.trim());
                const response = await miscService.regenerateS3Links(s3Links);
                refreshedS3Links.value = response;
            }
            catch (error) {
                errorMessage.value = error instanceof ApiError ? error.message.toString() : `An unknown error occurred: ${error}`;
            }
            finally {
                loading.value = false;
            }
        };
        return (_ctx, _cache) => {
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(PriorHeader),
                _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Ops Utilities", -1)),
                        _createVNode(_component_v_container, null, {
                            default: _withCtx(() => [
                                (errorMessage.value)
                                    ? (_openBlock(), _createBlock(_component_v_alert, {
                                        key: 0,
                                        type: "error",
                                        variant: "tonal",
                                        closable: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(errorMessage.value), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createElementVNode("h2", null, "Refresh S3 Links", -1)
                                            ])),
                                            _: 1,
                                            __: [1]
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    modelValue: s3LinksForRefresh.value,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((s3LinksForRefresh).value = $event)),
                                                    label: "S3 Links"
                                                }, null, 8, ["modelValue"]),
                                                _cache[2] || (_cache[2] = _createTextVNode(" Please paste a comma separated list of S3 links, with or without quotes or \"[]\" (can also be just one link). ", -1))
                                            ]),
                                            _: 1,
                                            __: [2]
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_btn, {
                                                    loading: loading.value,
                                                    onClick: refreshS3Link
                                                }, {
                                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                        _createTextVNode("Refresh S3 Link", -1)
                                                    ])),
                                                    _: 1,
                                                    __: [3]
                                                }, 8, ["loading"])
                                            ]),
                                            _: 1
                                        }),
                                        (refreshedS3Links.value.length > 0)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "12"
                                            }, {
                                                default: _withCtx(() => [
                                                    _cache[4] || (_cache[4] = _createElementVNode("b", null, "Refreshed S3 Links:", -1)),
                                                    _createVNode(_component_v_list, null, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refreshedS3Links.value, (link) => {
                                                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                    key: link,
                                                                    style: { 'line-break': 'anywhere' }
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(link), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1024));
                                                            }), 128))
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1,
                                                __: [4]
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1,
                    __: [5]
                }),
                _createVNode(PriorFooter)
            ], 64));
        };
    }
});
